const miniBasket = document.getElementById('js-mini-basket');

if(miniBasket) {
    const triggers = document.querySelectorAll('.js-toggle-mini-basket');
    const backdrop = document.getElementById('js-mini-basket-backdrop');

    const toggleBasket = () => {
        miniBasket.classList.toggle("mini-basket--active");
        backdrop.classList.toggle("mini-basket__backdrop--active");
    }

    const openBasket = () => {
        miniBasket.classList.add("mini-basket--active");
        backdrop.classList.add("mini-basket__backdrop--active");
    }

    triggers.forEach(trigger => {
        trigger.addEventListener("click", () => {
            toggleBasket();
        })
    });

    if(window.location.hash === '#added') {
        openBasket();
    }
}